// This function maps from the REST sunglasses variant type to our Client-side ProductFeature[] type
const getProductFeatures = (serverVariant)=>{
    const productFeatures = [];
    const { glazable , polarized , uvCategory  } = serverVariant.features;
    if (!!uvCategory) {
        productFeatures.push({
            type: 'uvCategory',
            iconName: 'uv'
        });
    }
    if (!!polarized) {
        productFeatures.push({
            type: 'polarized',
            iconName: 'polarized'
        });
    }
    if (!!glazable) {
        productFeatures.push({
            type: 'glazeable',
            iconName: 'reading'
        });
    }
    return productFeatures;
};

export { getProductFeatures };
//# sourceMappingURL=get-product-features.js.map
